import { Component } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {

  handleClick(ev: Event) {
    console.log('Debug angular click event', ev);
  }

}
